import { getApps, initializeApp, type FirebaseApp } from "firebase/app";
import { getMessaging, isSupported, type Messaging } from "firebase/messaging";

/**
 * Initialisation paresseuse de Firebase (Cloud Messaging uniquement — pas
 * d'analytics). La config web est publique par nature ; elle est lue depuis
 * les variables `VITE_FIREBASE_*` (voir `.env.example`).
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

/** Les trois champs sans lesquels `initializeApp` ne peut pas fonctionner. */
export function isFirebaseConfigured(): boolean {
  return Boolean(
    firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId
  );
}

let app: FirebaseApp | null = null;

/** Singleton module : `initializeApp` n'est appelé qu'une fois. */
export function getFirebaseApp(): FirebaseApp {
  if (!app) {
    const existing = getApps();
    app = existing.length > 0 ? existing[0] : initializeApp(firebaseConfig);
  }
  return app;
}

/**
 * Retourne l'instance Messaging, ou `null` si le navigateur ne supporte pas
 * FCM (service worker / Push API absents — ex. Safari iOS hors PWA).
 */
export async function getFirebaseMessaging(): Promise<Messaging | null> {
  if (!(await isSupported())) {
    return null;
  }
  return getMessaging(getFirebaseApp());
}
